var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3536 8.35355C24.5488 8.15829 24.5488 7.84171 24.3536 7.64645L21.1716 4.46447C20.9763 4.2692 20.6597 4.2692 20.4645 4.46447C20.2692 4.65973 20.2692 4.97631 20.4645 5.17157L23.2929 8L20.4645 10.8284C20.2692 11.0237 20.2692 11.3403 20.4645 11.5355C20.6597 11.7308 20.9763 11.7308 21.1716 11.5355L24.3536 8.35355ZM0 8.5H24V7.5H0L0 8.5Z",
    fill: "#EC7440"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientRightArrow);
export default __webpack_public_path__ + "static/media/clientRightArrow.7c1a3aa04bfbf82e4fddc758a5bc8d37.svg";
export { ForwardRef as ReactComponent };